import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


const CmsElementDynamicElement = (props) => {
  const {
    editMode,
    index,
    showElementSettings,
    children
  } = props;

  // CMS Logic Hook
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: index,
    disabled: !editMode
  });

  // Local State für UI-Overlays
  const [mouseOver, setMouseOver] = useState(false);

  // Styles
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative'
  };

  const isVisible = editMode || shown;
  const shownClass = isVisible ? 'elem-shown' : 'elem-hidden';

  const parallaxData = getParallaxData();

  const innerContent = (
    <div
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      onDragLeave={() => setMouseOver(false)}
    >
      {elementStyleTag}

      <div
        id={getMainId() || `ms_${index.toString().replace(/\./g, '_')}`}
        className={`ms-dyn-el ${shownClass} ${isDragging ? 'ms-dyn-el-dragging' : ''} ${cssClasses} ${responsiveClasses}`.trim()}
        style={getBackgroundStyle()}
      >
        {/* Show outline and menu only in edit mode on mouseover */}
        {mouseOver && editMode && (
          <>
            <span className="ms-dyn-el-outline ms-dyn-el-outline-top" />
            <span className="ms-dyn-el-outline ms-dyn-el-outline-right" />
            <span className="ms-dyn-el-outline ms-dyn-el-outline-bottom" />
            <span className="ms-dyn-el-outline ms-dyn-el-outline-left" />

            <div className="ms-dyn-el-menu">
              {/* Drag Handle: attributes and listeners are applied to the icon here */}
              <span
                className="btn bg-transparent text-white b-hide"
                {...attributes}
                {...listeners}
                style={{ cursor: 'move' }}
              >
                <i className="fa fa-arrows-alt" />
              </span>

              <Button onClick={(e) => showElementSettings(e, index)}>
                <i className="fa fa-cog" />
              </Button>
            </div>
          </>
        )}

        <div>
          {children}
          <div className="clearfix"></div>
        </div>

        {getAppendHtml()}
      </div>
    </div>
  );

  return (
    <div ref={setNodeRef} style={dndStyle}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
};

export default CmsElementDynamicElement;
